package com.tedd.db

import kotlin.Long
import kotlin.String

public data class Objective(
  public val id: String,
  public val category_id: String?,
  public val title: String,
  public val description: String?,
  public val motivation: String?,
  public val deadline: String?,
  public val year: Long?,
  public val status: String,
  public val progress: Long,
  public val skill_id: String?,
  public val step_id: String?,
  public val created_at: Long,
  public val updated_at: Long,
  public val is_deleted: Long,
  public val deleted_at: Long?,
  public val synced_at: Long?,
)
